import { useEffect } from "react";
import useHandleTheme from "./theme/useHandleTheme";

export default function useEffectFirstLoad() {
  const handleTheme = useHandleTheme();
  useEffect(() => {
    handleTheme.setDefaultTheme();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
